module.exports = __webpack_public_path__ + "static/media/povWireframe.920e5207.png";